<img *ngIf="isImage" [src]="model.file.url" />
